import { route } from '@/ziggy-shim';
import { api, CastValue } from './LaravelClient';

export default {
  async index(data: ApiRequests['api.v1.notifications.index']) {
    return await api(route('api.v1.notifications.index'), 'get', {
      data,
    });
  },

  async markAllAsRead() {
    return await api(route('api.v1.notifications.mark-all-read'), 'post');
  },

  async destroy(notificationId: string) {
    return await api(route('api.v1.notifications.destroy', { notification: notificationId }), 'delete');
  },

  async destroyAll() {
    return await api(route('api.v1.notifications.destroy-all'), 'delete');
  },
};
